(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdl-conversion-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCB(scope){
    (scope||document).querySelectorAll('.pdlcb__bg-video[data-src]').forEach(function(v){
      var io = new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting){ if(!v.dataset.loaded){var s=document.createElement('source');s.src=v.dataset.src;s.type='video/mp4';v.appendChild(s);v.load();v.dataset.loaded='1';} var p=v.play();if(p&&p.catch)p.catch(function(){}); }
        else if(!v.paused){v.pause();}
      });},{threshold:0.2});
      io.observe(v);
    });
  }
  if(document.readyState!=='loading')initCB();else document.addEventListener('DOMContentLoaded',function(){initCB();});
  document.addEventListener('shopify:section:load',function(e){initCB(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-video-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVF(scope) {
    var vids = (scope || document).querySelectorAll('.pdlvf__video[data-src]');
    if (!vids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) {
            var s = document.createElement('source');
            s.src = v.dataset.src; s.type = 'video/mp4';
            v.appendChild(s); v.load(); v.dataset.loaded = '1';
          }
          v.muted = true; v.setAttribute('playsinline',''); var p = v.play(); if (p && p.catch) p.catch(function(){});
        } else {
          if (!v.paused) v.pause();
        }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });

    (scope || document).querySelectorAll('[data-pdlvf-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var frame = btn.closest('.pdlvf__video-frame');
        var v = frame && frame.querySelector('.pdlvf__video');
        if (!v) return;
        v.muted = !v.muted;
        var off = btn.querySelector('.pdlvf__sound-off');
        var on = btn.querySelector('.pdlvf__sound-on');
        if (off) off.style.display = v.muted ? '' : 'none';
        if (on) on.style.display = v.muted ? 'none' : '';
        if (v.muted === false) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      });
    });
  }
  if (document.readyState !== 'loading') initVF(); else document.addEventListener('DOMContentLoaded', function(){ initVF(); });
  document.addEventListener('shopify:section:load', function (e) { initVF(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdl-video-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVG(scope) {
    var vids = (scope || document).querySelectorAll('.pdlvg__video[data-src]');
    if (!vids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) {
            var s = document.createElement('source'); s.src = v.dataset.src; s.type = 'video/mp4';
            v.appendChild(s); v.load(); v.dataset.loaded = '1';
          }
          v.muted = true; v.setAttribute('playsinline',''); var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') initVG(); else document.addEventListener('DOMContentLoaded', function(){ initVG(); });
  document.addEventListener('shopify:section:load', function (e) { initVG(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
